export default __webpack_public_path__ + "static/media/arrow-right.6b68ca95.svg";